'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var React = require('react');
var context = require('@andes/context');
var _objectSpread = require('@babel/runtime/helpers/objectSpread2');
var _jsx = require('@babel/runtime/helpers/jsx');
var classNames = require('classnames');
require('@andes/common/build/utils/propTypesValidators');
var carouselSnapped = require('@andes-headless/carousel-snapped');
var common = require('@andes/common');
var isMobile = require('@andes/common/build/utils/isMobile');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var _objectSpread__default = /*#__PURE__*/_interopDefaultLegacy(_objectSpread);
var _jsx__default = /*#__PURE__*/_interopDefaultLegacy(_jsx);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);
var isMobile__default = /*#__PURE__*/_interopDefaultLegacy(isMobile);
function addClass(el, list) {
  if (list === undefined) {
    list = [];
  }
  if (!Array.isArray(list)) list = [list];
  list.forEach(clz => !el.classList.contains(clz) && el.classList.add(clz));
}
function removeClass(el, list) {
  if (list === undefined) {
    list = [];
  }
  if (!Array.isArray(list)) list = [list];
  list.forEach(clz => el.classList.contains(clz) && el.classList.remove(clz));
}
function attachListener$1(el, evtName, handler, opts) {
  el.addEventListener(evtName, handler, opts);
}
function detachListener$1(el, evtName, handler) {
  el.removeEventListener(evtName, handler);
}
function setAttr(el, attr, value) {
  if (value === undefined) {
    value = '';
  }
  el.setAttribute(attr, value);
  return el;
}
function setStyle(el, style, forceRender) {
  Object.keys(style).forEach(prop => {
    el.style[prop] = style[prop];
  });
  forceRender && getComputedStyle(el);
  return el;
}
function getTranslate(el, isHorizontal) {
  const matrix = getComputedStyle(el).transform.replace(/[a-z]|\(|\)|\s/g, '').split(',').map(parseFloat);
  let arr = [];
  if (matrix.length === 16) {
    arr = matrix.slice(12, 14);
  } else if (matrix.length === 6) {
    arr = matrix.slice(4, 6);
  }
  return arr[isHorizontal ? 0 : 1] || 0;
}
function translate(state, env, options, duration) {
  const {
    $wrapper
  } = env.element;
  const wrapperStyle = {
    transition: state.isStart ? 'none' : "transform ease ".concat(duration, "ms"),
    transform: options.isHorizontal ? "translate3d(".concat(state.transforms, "px, 0, 0)") : "translate3d(0, ".concat(state.transforms, "px, 0)")
  };
  if ([...env.element.$list].reduce((prev, curr) => prev + curr.clientWidth + options.spaceBetween, 0) >= env.element.$el.offsetWidth) {
    setStyle($wrapper, wrapperStyle);
  }
}
const defaultOptions = {
  direction: 'horizontal',
  touchRatio: 1,
  touchAngle: 45,
  longSwipesRatio: 0.5,
  initialSlide: 0,
  loop: false,
  freeMode: false,
  passiveListeners: true,
  resistance: true,
  resistanceRatio: 0.85,
  speed: 300,
  longSwipesMs: 300,
  spaceBetween: 0,
  slidesPerView: 1,
  centeredSlides: false,
  slidePrevClass: 'swiper-slide-prev',
  slideNextClass: 'swiper-slide-next',
  slideActiveClass: 'swiper-slide-active',
  slideClass: 'swiper-slide',
  wrapperClass: 'swiper-wrapper',
  touchStartPreventDefault: true,
  touchStartForcePreventDefault: false,
  touchMoveStopPropagation: false,
  excludeElements: [],
  injections: {
    translate
  }
};
function optionFormatter(userOptions) {
  const options = _objectSpread__default["default"](_objectSpread__default["default"]({}, defaultOptions), userOptions);
  return _objectSpread__default["default"](_objectSpread__default["default"]({}, options), {}, {
    isHorizontal: options.direction === 'horizontal'
  });
}
const LIFE_CYCLES = {
  BEFORE_INIT: 'before-init',
  AFTER_INIT: 'after-init',
  BEFORE_SLIDE: 'before-slide',
  SCROLL: 'scroll',
  AFTER_SLIDE: 'after-slide',
  BEFORE_DESTROY: 'before-destroy',
  AFTER_DESTROY: 'after-destroy'
};
function EventHub() {
  let hub = {};
  function on(evtName, cb) {
    if (!hub[evtName]) {
      hub[evtName] = [cb];
    } else {
      hub[evtName].push(cb);
    }
  }
  function off(evtName, cb) {
    if (hub[evtName]) {
      const index = hub[evtName].indexOf(cb);
      index > -1 && hub[evtName].splice(index, 1);
    }
  }
  function emit(evtName) {
    for (var _len = arguments.length, data = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      data[_key - 1] = arguments[_key];
    }
    if (hub[evtName]) {
      hub[evtName].forEach(cb => cb(...data));
    }
  }
  function clear() {
    hub = {};
  }
  return {
    on,
    off,
    emit,
    clear
  };
}
const delta = 180 / Math.PI;
function Vector(logs, index) {
  const trace = logs[index];
  const formerTrace = logs[index - 1] || trace;
  const diff = {
    x: trace.x - formerTrace.x,
    y: trace.y - formerTrace.y
  };
  const duration = trace.time - formerTrace.time;
  const velocityX = diff.x / duration || 0;
  const velocityY = diff.y / duration || 0;
  const angle = Math.atan2(Math.abs(diff.y), Math.abs(diff.x)) * delta;
  return _objectSpread__default["default"](_objectSpread__default["default"]({}, diff), {}, {
    angle,
    velocityX,
    velocityY
  });
}
function Tracker() {
  let logs = [];
  function push(position) {
    logs.push(_objectSpread__default["default"]({
      time: Date.now()
    }, position));
  }
  function vector() {
    return Vector(logs, logs.length - 1);
  }
  function clear() {
    logs = [];
  }
  function getLogs() {
    return logs;
  }
  function getDuration() {
    const first = logs[0];
    const last = logs[logs.length - 1];
    return first ? last.time - first.time : 0;
  }
  function getOffset() {
    const first = logs[0];
    const last = logs[logs.length - 1];
    return first ? {
      x: last.x - first.x,
      y: last.y - first.y
    } : {
      x: 0,
      y: 0
    };
  }
  return {
    getDuration,
    getOffset,
    getLogs,
    vector,
    clear,
    push
  };
}
function State() {
  const state = {
    tracker: Tracker(),
    index: 0,
    startTransform: 0,
    isStart: false,
    isScrolling: false,
    isTouching: false,
    transforms: 0,
    progress: 0
  };
  return state;
}
function now() {
  return performance ? performance.now() : Date.now();
}
function Tick() {
  const nextFrame = requestAnimationFrame || webkitRequestAnimationFrame || setTimeout;
  const cancelNextFrame = cancelAnimationFrame || webkitCancelAnimationFrame || clearTimeout;
  let startTime;
  let id;
  function run(cb) {
    startTime = startTime === undefined ? now() : startTime;
    id = nextFrame(() => {
      const timeStamp = now();
      const interval = timeStamp - startTime;
      startTime = timeStamp;
      cb(interval);
    });
  }
  function stop() {
    startTime = undefined;
    cancelNextFrame(id);
  }
  return {
    run,
    stop
  };
}
function Animation() {
  const tick = Tick();
  function run(task) {
    tick.run(interval => {
      run(task);
      task(interval);
    });
  }
  function stop() {
    tick.stop();
  }
  return {
    run,
    stop
  };
}
function resetState(state, operations) {
  const {
    tracker
  } = state;
  const {
    initStatus
  } = operations;
  tracker.clear();
  initStatus();
}
function Actions(options, env, state, operations) {
  const {
    initLayout
  } = operations;
  const {
    initStatus
  } = operations;
  const {
    render
  } = operations;
  const {
    scrollPixel
  } = operations;
  const {
    slideTo
  } = operations;
  const {
    getOffsetSteps
  } = operations;
  const animation = Animation();
  function preheat(originPosition, originTransform) {
    const {
      tracker
    } = state;
    animation.stop();
    tracker.clear();
    tracker.push(originPosition);
    initLayout(originTransform);
    initStatus(originTransform);
    state.isStart = true;
    render();
  }
  function move(position) {
    const {
      tracker
    } = state;
    const {
      touchRatio
    } = options;
    const {
      touchAngle
    } = options;
    const {
      isHorizontal
    } = options;
    if (!state.isStart || state.isScrolling) return;
    tracker.push(position);
    const vector = tracker.vector();
    const displacement = tracker.getOffset();
    if (!displacement.x && !displacement.y) return;
    if (isHorizontal && vector.angle < touchAngle || !isHorizontal && 90 - vector.angle < touchAngle || state.isTouching) {
      const offset = vector[isHorizontal ? 'x' : 'y'] * touchRatio;
      state.isTouching = true;
      scrollPixel(offset);
      render();
    } else {
      state.isScrolling = true;
      tracker.clear();
    }
  }
  function stop() {
    const {
      index
    } = state;
    const {
      tracker
    } = state;
    const {
      measure
    } = env;
    if (!state.isStart) return;
    state.isStart = false;
    if (!options.freeMode) {
      const duration = tracker.getDuration();
      const trans = tracker.getOffset()[options.isHorizontal ? 'x' : 'y'];
      const jump = Math.ceil(Math.abs(trans) / measure.boxSize);
      const longSwipeIndex = getOffsetSteps(trans);
      if (duration > options.longSwipesMs) {
        slideTo(index + longSwipeIndex * (trans > 0 ? -1 : 1));
      } else {
        slideTo(trans > 0 ? index - jump : index + jump);
      }
      resetState(state, operations);
    } else {
      const vector = tracker.vector();
      let velocity = vector[options.isHorizontal ? 'velocityX' : 'velocityY'];
      animation.run(duration => {
        const offset = velocity * duration;
        velocity *= 0.98;
        if (Math.abs(offset) < 0.01) {
          animation.stop();
          resetState(state, operations);
        } else {
          scrollPixel(offset);
          render(0);
        }
      });
    }
  }
  return {
    preheat,
    move,
    stop
  };
}
function Sensor(env, state, options, operations) {
  const {
    touchable
  } = env;
  const formEls = ['INPUT', 'SELECT', 'OPTION', 'TEXTAREA', 'BUTTON', 'VIDEO'];
  const actions = Actions(options, env, state, operations);
  const {
    preheat
  } = actions;
  const {
    move
  } = actions;
  const {
    stop
  } = actions;
  function getPosition(e) {
    const touch = touchable ? e.changedTouches[0] : e;
    return {
      x: touch.pageX,
      y: touch.pageY
    };
  }
  function onTouchStart(e) {
    for (let i = 0; i < options.excludeElements.length; i++) {
      if (options.excludeElements[i].contains(e.target)) return;
    }
    const {
      $wrapper
    } = env.element;
    const shouldPreventDefault = options.touchStartPreventDefault && formEls.indexOf(e.target.nodeName) === -1 || options.touchStartForcePreventDefault;
    if (!touchable && shouldPreventDefault) e.preventDefault();
    preheat(getPosition(e), getTranslate($wrapper, options.isHorizontal));
  }
  function onTouchMove(e) {
    if (options.touchMoveStopPropagation) e.stopPropagation();
    move(getPosition(e));
    if (state.isTouching && e.cancelable !== false) e.preventDefault();
  }
  function onTouchEnd() {
    stop();
  }
  function attach() {
    const {
      $el
    } = env.element;
    if (touchable) {
      attachListener$1($el, 'touchstart', onTouchStart, {
        passive: options.passiveListeners,
        capture: false
      });
      attachListener$1($el, 'touchmove', onTouchMove);
      attachListener$1($el, 'touchend', onTouchEnd);
      attachListener$1($el, 'touchcancel', onTouchEnd);
    } else {
      attachListener$1($el, 'mousedown', onTouchStart);
      if (typeof document !== 'undefined') {
        attachListener$1(document, 'mousemove', onTouchMove);
        attachListener$1(document, 'mouseup', onTouchEnd);
      }
    }
  }
  function detach() {
    const {
      $el
    } = env.element;
    detachListener$1($el, 'touchstart', onTouchStart);
    detachListener$1($el, 'touchmove', onTouchMove);
    detachListener$1($el, 'touchend', onTouchEnd);
    detachListener$1($el, 'touchcancel', onTouchEnd);
    detachListener$1($el, 'mousedown', onTouchStart);
    if (typeof document !== 'undefined') {
      detachListener$1(document, 'mousemove', onTouchMove);
      detachListener$1(document, 'mouseup', onTouchEnd);
    }
  }
  return {
    attach,
    detach
  };
}
function Measure(options, element) {
  const {
    $el
  } = element;
  const viewSize = options.isHorizontal ? $el.offsetWidth : $el.offsetHeight;
  const slideSize = (viewSize - Math.ceil(options.slidesPerView - 1) * options.spaceBetween) / options.slidesPerView;
  const boxSize = slideSize + options.spaceBetween;
  return {
    boxSize,
    viewSize,
    slideSize
  };
}
function getExpand(options) {
  if (options.loop) {
    return Math.ceil(options.slidesPerView);
  }
  return 0;
}
function Limitation(element, measure, options) {
  const {
    $list
  } = element;
  const {
    viewSize
  } = measure;
  const {
    slideSize
  } = measure;
  const {
    boxSize
  } = measure;
  const expand = getExpand(options);
  const buffer = expand * boxSize;
  const base = -buffer + (options.centeredSlides ? (viewSize - slideSize) / 2 : 0);
  const max = base;
  const min = options.spaceBetween + (options.loop ? slideSize : viewSize) + base - boxSize * $list.length;
  const minIndex = 0;
  const maxIndex = $list.length - (options.centeredSlides || options.loop ? 1 : Math.floor(options.slidesPerView));
  const limitation = {
    max,
    min,
    base,
    expand,
    buffer,
    minIndex,
    maxIndex
  };
  return limitation;
}
function Env(elem, options) {
  const env = {};
  function update(element) {
    const measure = Measure(options, element);
    const limitation = Limitation(element, measure, options);
    const touchable = typeof document !== 'undefined' && typeof window !== 'undefined' ? Boolean('ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0 || window.DocumentTouch && document instanceof DocumentTouch) : false;
    Object.assign(env, {
      touchable,
      element,
      measure,
      limitation
    });
  }
  env.update = update;
  update(elem);
  return env;
}
const shallowTag = 'data-shallow-slider';
const sliderTag = 'data-slider';
function Renderer(env, options) {
  function updateItem(state) {
    const {
      $wrapper
    } = env.element;
    const {
      index
    } = state;
    [].slice.call($wrapper.querySelectorAll("[".concat(sliderTag, "]"))).forEach($slide => {
      const tagNumber = ~~$slide.getAttribute(sliderTag);
      removeClass($slide, [options.slidePrevClass, options.slideNextClass, options.slideActiveClass]);
      if (tagNumber === index) {
        addClass($slide, options.slideActiveClass);
      }
      if (tagNumber === index - 1) {
        addClass($slide, options.slidePrevClass);
      }
      if (tagNumber === index + 1) {
        addClass($slide, options.slideNextClass);
      }
    });
  }
  function render(state, duration, cb, force) {
    const {
      $wrapper
    } = env.element;
    const timing = duration === undefined ? options.speed : duration;
    options.injections.translate(state, env, options, timing);
    if (!state.isStart) updateItem(state);
    force && getComputedStyle($wrapper).transform;
    cb && setTimeout(cb, timing);
  }
  function appendExpandList() {
    if (!options.loop) return;
    const {
      element
    } = env;
    const {
      limitation
    } = env;
    const {
      $list
    } = element;
    const {
      $wrapper
    } = element;
    const {
      expand
    } = limitation;
    const $leftExpandList = $list.slice(-expand).map($slide => $slide.cloneNode(true));
    const $rightExpandList = $list.slice(0, expand).map($slide => $slide.cloneNode(true));
    $leftExpandList.forEach(($shadowSlide, index) => {
      $wrapper.appendChild(setAttr($rightExpandList[index], shallowTag));
      $wrapper.insertBefore(setAttr($leftExpandList[index], shallowTag), $list[0]);
    });
  }
  function destroyExpandList() {
    [].slice.call(env.element.$wrapper.querySelectorAll("[".concat(shallowTag, "]"))).forEach(item => env.element.$wrapper.removeChild(item));
  }
  function updateDom() {
    env.element.$list.forEach((el, index) => setAttr(el, sliderTag, index));
    destroyExpandList();
    appendExpandList();
  }
  function updateSize() {
    let _itemStyle;
    const {
      element
    } = env;
    const {
      measure
    } = env;
    const {
      $wrapper
    } = element;
    const wrapperStyle = {
      display: 'flex',
      willChange: 'transform',
      flexDirection: options.isHorizontal ? 'row' : 'column'
    };
    const itemStyle = (_itemStyle = {}, _itemStyle[options.isHorizontal ? 'width' : 'height'] = "".concat(measure.slideSize, "px"), _itemStyle[options.isHorizontal ? 'margin-right' : 'margin-bottom'] = "".concat(options.spaceBetween, "px"), _itemStyle);
    setStyle($wrapper, wrapperStyle);
    [].slice.call($wrapper.querySelectorAll("[".concat(sliderTag, "]"))).forEach($slide => setStyle($slide, itemStyle));
  }
  function init() {
    updateDom();
    updateSize();
  }
  function destroy() {
    const _env$element = env.element;
    const {
      $list
    } = _env$element;
    const {
      $wrapper
    } = _env$element;
    const arr = ['display', 'will-change', 'flex-direction'];
    const itemProp = options.isHorizontal ? 'margin-right' : 'margin-bottom';
    arr.forEach(propertyName => {
      $wrapper.style.removeProperty(propertyName);
    });
    $list.forEach($slide => $slide.style.removeProperty(itemProp));
    destroyExpandList();
  }
  return {
    init,
    render,
    destroy,
    updateSize
  };
}
function isExceedingLimits(velocity, transform, limitation) {
  return velocity > 0 && transform > limitation.max || velocity < 0 && transform < limitation.min;
}
function getShortestWay(currentIndex, targetIndex, limitation, defaultWay) {
  const {
    maxIndex
  } = limitation;
  const {
    minIndex
  } = limitation;
  const shortcut = (defaultWay > 0 ? 1 : -1) * (minIndex - maxIndex - 1) + targetIndex - currentIndex;
  return Math.abs(defaultWay) > Math.abs(shortcut) ? shortcut : defaultWay;
}
function getExcess(transform, limitation) {
  const exceedLeft = transform - limitation.max;
  const exceedRight = transform - limitation.min;
  return exceedLeft > 0 ? exceedLeft : exceedRight < 0 ? exceedRight : 0;
}
function Operations(env, state, options, renderer, eventHub) {
  function getOffsetSteps(offset) {
    const {
      measure
    } = env;
    return Math.ceil(Math.abs(offset) / measure.boxSize - options.longSwipesRatio);
  }
  function render(duration, cb, force) {
    renderer.render(state, duration, cb, force);
  }
  function transform(trans) {
    const _env$limitation = env.limitation;
    const {
      min
    } = _env$limitation;
    const {
      max
    } = _env$limitation;
    const transRange = max - min + (options.loop ? env.measure.boxSize : 0);
    const len = transRange + 1;
    let progress;
    state.transforms = trans;
    if (options.loop) {
      progress = (max - trans) % len / transRange;
      state.progress = progress < 0 ? 1 + progress : progress > 1 ? progress - 1 : progress;
    } else {
      progress = (max - trans) / transRange;
      state.progress = progress < 0 ? 0 : progress > 1 ? 1 : progress;
    }
    eventHub.emit(LIFE_CYCLES.SCROLL, _objectSpread__default["default"]({}, state));
  }
  function slideTo(targetIndex, duration) {
    const {
      measure
    } = env;
    const {
      limitation
    } = env;
    const len = limitation.maxIndex - limitation.minIndex + 1;
    const computedIndex = options.loop ? (targetIndex % len + len) % len : targetIndex > limitation.maxIndex ? limitation.maxIndex : targetIndex < limitation.minIndex ? limitation.minIndex : targetIndex;
    const newTransform = options !== null && options !== void 0 && options.loop ? targetIndex > limitation.maxIndex ? limitation.max : -computedIndex * measure.boxSize + limitation.base : targetIndex >= limitation.maxIndex ? limitation.min : -computedIndex * measure.boxSize + limitation.base;
    const hasSlideChange = state.index !== computedIndex;
    if (getOffsetSteps(newTransform - state.transforms) !== 0 && options.loop) {
      const excess = getExcess(state.transforms, limitation);
      const defaultWay = computedIndex - state.index;
      const shortcut = getShortestWay(state.index, computedIndex, limitation, defaultWay);
      if (shortcut !== defaultWay && !excess) {
        transform(shortcut < 0 ? limitation.min - measure.boxSize : limitation.max + measure.boxSize);
      } else if (state.index === computedIndex) {
        transform(excess > 0 ? limitation.min - measure.boxSize + excess : limitation.max + measure.boxSize + excess);
      }
      render(0, undefined, true);
    }
    if (hasSlideChange) {
      eventHub.emit(LIFE_CYCLES.BEFORE_SLIDE, state.index, state, computedIndex);
    }
    state.index = computedIndex;
    transform(newTransform);
    render(duration, () => {
      if (hasSlideChange) {
        eventHub.emit(LIFE_CYCLES.AFTER_SLIDE, computedIndex, state, state.index);
      }
    });
  }
  function scrollPixel(px) {
    const {
      transforms
    } = state;
    const {
      measure
    } = env;
    const {
      limitation
    } = env;
    const ratio = Number(px.toExponential().split('e')[1]);
    const expand = ratio <= 0 ? Math.pow(10, -(ratio - 1)) : 1;
    let newTransform = transforms;
    if (options.resistance && !options.loop) {
      if (px > 0 && transforms >= limitation.max) {
        px -= Math.pow(px * expand, options.resistanceRatio) / expand;
      } else if (px < 0 && transforms <= limitation.min) {
        px += Math.pow(-px * expand, options.resistanceRatio) / expand;
      }
    }
    newTransform += px;
    if (options.loop) {
      const vector = state.tracker.vector();
      const velocity = options.isHorizontal ? vector.velocityX : vector.velocityY;
      const excess = getExcess(transforms, limitation);
      if (excess && isExceedingLimits(velocity, transforms, limitation)) {
        newTransform = excess > 0 ? limitation.min - measure.boxSize + excess : limitation.max + measure.boxSize + excess;
      }
    }
    transform(newTransform);
  }
  function initStatus(startTransform) {
    if (startTransform === undefined) {
      startTransform = 0;
    }
    state.startTransform = startTransform;
    state.isStart = false;
    state.isScrolling = false;
    state.isTouching = false;
  }
  function initLayout(originTransform) {
    transform(originTransform);
  }
  function update() {
    slideTo(state.index, 0);
    renderer.updateSize();
  }
  return {
    update,
    render,
    transform,
    slideTo,
    scrollPixel,
    initStatus,
    initLayout,
    getOffsetSteps
  };
}
function Element(el, options) {
  const $el = typeof el === 'string' && typeof document !== 'undefined' ? document.body.querySelector(el) : el;
  const $wrapper = $el.querySelector(".".concat(options.wrapperClass));
  let $list = [].slice.call($el.getElementsByClassName(options.slideClass));
  $list = $list.filter(slide => slide.getAttribute('data-shallow-slider') === null);
  return {
    $el,
    $wrapper,
    $list
  };
}
const Swiper = function Swiper(el, userOptions) {
  const options = optionFormatter(userOptions);
  const eventHub = EventHub();
  const element = Element(el, options);
  const env = Env(element, options);
  const state = State();
  const {
    on
  } = eventHub;
  const {
    off
  } = eventHub;
  const {
    emit
  } = eventHub;
  const instance = {
    on,
    off,
    env,
    state,
    options
  };
  (options.plugins || Swiper.plugins || []).forEach(plugin => plugin(instance, options));
  emit(LIFE_CYCLES.BEFORE_INIT, instance);
  const renderer = Renderer(env, options);
  const operations = Operations(env, state, options, renderer, eventHub);
  const sensor = Sensor(env, state, options, operations);
  function destroy() {
    emit(LIFE_CYCLES.BEFORE_DESTROY, instance);
    sensor.detach();
    renderer.destroy();
    emit(LIFE_CYCLES.AFTER_DESTROY, instance);
    eventHub.clear();
  }
  function updateSize() {
    env.update(Element(el, options));
    operations.update();
  }
  function update() {
    renderer.destroy();
    env.update(Element(el, options));
    renderer.init();
    operations.update();
  }
  const {
    slideTo
  } = operations;
  Object.assign(instance, {
    update,
    destroy,
    slideTo,
    updateSize
  });
  renderer.init();
  sensor.attach();
  slideTo(options.initialSlide, 0, false);
  emit(LIFE_CYCLES.AFTER_INIT, instance);
  return instance;
};
Swiper.use = plugins => {
  Swiper.plugins = plugins;
};
var Swiper$1 = Swiper;
const attachListener = (el, evtName, handler, opts) => {
  el.addEventListener(evtName, handler, opts);
};
const detachListener = (el, evtName, handler) => {
  el.removeEventListener(evtName, handler);
};
const SwiperPluginNavigation = function SwiperPluginNavigation(instance, options) {
  const isEnable = Boolean(options.navigation);
  const navigationInstance = {};
  const navigationOptions = _objectSpread__default["default"]({
    disabledClass: 'swiper-button-disabled'
  }, options.navigation);
  const checkIsDisable = function checkIsDisable(e) {
    return e.classList.contains(navigationOptions.disabledClass);
  };
  const clickHandler = function clickHandler(e, type) {
    if (checkIsDisable(e) && !instance.options.loop) {
      return;
    }
    const {
      index
    } = instance.state;
    if (type === 'next') {
      instance.slideTo(index + 1);
    }
    if (type === 'prev') {
      instance.slideTo(index - 1);
    }
  };
  const nextClickHandler = e => {
    clickHandler(e.target, 'next');
  };
  const prevClickHandler = e => {
    clickHandler(e.target, 'prev');
  };
  const checkNavBtnDisabledClass = function checkNavBtnDisabledClass(index) {
    const limit = instance.env.limitation;
    const {
      minIndex
    } = limit;
    const {
      maxIndex
    } = limit;
    if (navigationInstance && navigationInstance.prevEl && navigationInstance.nextEl) {
      if (navigationInstance.nextEl.classList.contains(navigationOptions.disabledClass) && index >= minIndex) {
        navigationInstance.nextEl.classList.remove(navigationOptions.disabledClass);
      }
      if (navigationInstance.prevEl.classList.contains(navigationOptions.disabledClass) && index <= maxIndex) {
        navigationInstance.prevEl.classList.remove(navigationOptions.disabledClass);
      }
      if (index === minIndex) {
        navigationInstance.prevEl.classList.add(navigationOptions.disabledClass);
      }
      if (index === maxIndex) {
        navigationInstance.nextEl.classList.add(navigationOptions.disabledClass);
      }
    }
  };
  const checkButtonDefaultStatus = function checkButtonDefaultStatus() {
    const {
      index
    } = instance.state;
    const {
      $list
    } = instance.env.element;
    const {
      minIndex
    } = instance.env.limitation;
    if (index === minIndex && navigationInstance.prevEl) {
      navigationInstance.prevEl.classList.add(navigationOptions.disabledClass);
    }
    if ($list.length === minIndex && navigationInstance.nextEl) {
      navigationInstance.nextEl.classList.add(navigationOptions.disabledClass);
    }
  };
  instance.on('before-slide', (currentIndex, state, newIndex) => {
    if (!instance.options.loop) {
      checkNavBtnDisabledClass(newIndex);
    }
  });
  instance.on('after-init', () => {
    var _instance$env$element;
    const container = (_instance$env$element = instance.env.element.$wrapper.parentElement) === null || _instance$env$element === void 0 ? void 0 : _instance$env$element.parentElement;
    if (!isEnable) return;
    navigationInstance.nextEl = typeof navigationOptions.nextEl === 'string' ? container.querySelector(navigationOptions.nextEl) : navigationOptions.nextEl;
    navigationInstance.prevEl = typeof navigationOptions.prevEl === 'string' ? container.querySelector(navigationOptions.prevEl) : navigationOptions.prevEl;
    if (!instance.options.loop) {
      checkButtonDefaultStatus();
    }
    if (navigationInstance.nextEl) {
      attachListener(navigationInstance.nextEl, 'click', nextClickHandler, undefined);
    }
    if (navigationInstance.prevEl) {
      attachListener(navigationInstance.prevEl, 'click', prevClickHandler, undefined);
    }
  });
  instance.on('after-destroy', () => {
    if (navigationInstance && navigationInstance.prevEl && navigationInstance.nextEl) {
      detachListener(navigationInstance.nextEl, 'click', nextClickHandler);
      detachListener(navigationInstance.prevEl, 'click', prevClickHandler);
      delete navigationInstance.nextEl;
      delete navigationInstance.prevEl;
    }
  });
};
var SwiperPluginNavigation$1 = SwiperPluginNavigation;
const defaultLazyloadOptions = {
  loadPrevNext: true,
  loadingClass: 'lazy-loadable',
  loadOnTransitionStart: true,
  loadMode: 'onload',
  loadPrevNextAmount: undefined
};
function lazyLoad(instance, options) {
  const lazyloadOptions = _objectSpread__default["default"](_objectSpread__default["default"]({}, defaultLazyloadOptions), options.lazyload);
  const lazyload = {
    load: index => {
      if (typeof window === 'undefined' || typeof window.imageLazyLoading === 'undefined') {
        return;
      }
      const idx = Math.sign(index) >= 0 ? index : instance.env.element.$list.length - Math.abs(index);
      const $slides = [].slice.call(instance.env.element.$wrapper.querySelectorAll("[data-slider=\"".concat(idx, "\"]")));
      if (!$slides) {
        return;
      }
      $slides.forEach($slide => {
        const $imgs = [].slice.call($slide.getElementsByClassName(lazyloadOptions.loadingClass));
        $imgs.forEach($img => {
          window.imageLazyLoading(lazyloadOptions.loadingClass, {
            loadMode: lazyloadOptions.loadMode
          }, $img);
        });
      });
    },
    loadRange: (index, range) => {
      lazyload.load(index);
      if (lazyloadOptions.loadPrevNext && range >= 1) {
        for (let i = 1; i <= range; i += 1) {
          lazyload.load(index + i);
          lazyload.load(index - i);
        }
      }
    }
  };
  instance.on('before-init', () => {
    instance.lazyload = lazyload;
  });
  const range = lazyloadOptions.loadPrevNextAmount || options.slidesPerView;
  if (lazyloadOptions.loadOnTransitionStart) {
    instance.on('before-slide', (_oldIndex, _state, newIndex) => lazyload.loadRange(newIndex, range));
  } else {
    instance.on('after-slide', index => lazyload.loadRange(index, range));
  }
}
const namespace = 'andes-carousel-snapped';
const controlNamespace = "".concat(namespace, "__control");
const slideNamespace = "".concat(namespace, "__slide");
const paginationNamespace = "".concat(namespace, "__pagination");
const wrapperNamespace = "".concat(namespace, "__wrapper");
const previousSlideNamespace = "".concat(slideNamespace, "--previous");
const nextSlideNamespace = "".concat(slideNamespace, "--next");
const activeSlideNamespace = "".concat(slideNamespace, "--active");
const CarouselSnappedControl = _ref => {
  let {
    type,
    onClick
  } = _ref;
  const {
    controls
  } = React.useContext(carouselSnapped.CarouselSnappedContext);
  const {
    disabled,
    size
  } = controls[type];
  const navigationControlClassnames = classNames__default["default"](controlNamespace, {
    ["".concat(controlNamespace, "--").concat(type)]: type,
    ["".concat(controlNamespace, "--size-").concat(size)]: size,
    ["".concat(controlNamespace, "--disabled")]: disabled
  });
  return /*#__PURE__*/_jsx__default["default"](carouselSnapped.CarouselSnappedControl, {
    className: navigationControlClassnames,
    onClick: onClick,
    type: type
  });
};
CarouselSnappedControl.displayName = 'CarouselSnappedControl';
var CarouselSnappedControl$1 = CarouselSnappedControl;
const CarouselSnappedPagination = _ref => {
  let {
    mode,
    position = 'inner'
  } = _ref;
  const paginationClassNames = classNames__default["default"](paginationNamespace, {
    ["".concat(paginationNamespace, "--").concat(mode)]: mode,
    ["".concat(paginationNamespace, "--position-").concat(position)]: position
  });
  return /*#__PURE__*/_jsx__default["default"](carouselSnapped.CarouselSnappedPagination, {
    className: paginationClassNames
  });
};
CarouselSnappedPagination.displayName = 'CarouselSnappedPagination';
var CarouselSnappedPagination$1 = CarouselSnappedPagination;
const getPagesNumber = (childrenAmount, slidesPerView) => {
  const newSlidesPerView = Math.floor(slidesPerView);
  if (newSlidesPerView <= 0) return 0;
  return Math.ceil(childrenAmount / newSlidesPerView);
};
const lastPageSlidesAmount = (childrenAmount, slidesPerView) => {
  const newSlidesPerView = Math.floor(slidesPerView);
  return childrenAmount % newSlidesPerView || newSlidesPerView;
};
const getCurrentPage = (activeSlide, slidesPerView, childrenAmount) => {
  const newSlidesPerView = Math.floor(slidesPerView);
  if (newSlidesPerView <= 0) return 0;
  const isLastPageIncomplete = lastPageSlidesAmount(childrenAmount, newSlidesPerView) < newSlidesPerView;
  if (isLastPageIncomplete && activeSlide >= childrenAmount - newSlidesPerView) {
    const lastPageIndex = getPagesNumber(childrenAmount, newSlidesPerView) - 1;
    return lastPageIndex;
  }
  return Math.floor(activeSlide / newSlidesPerView);
};
const getNextIndex = (activeSlide, slidesPerView, childrenAmount) => {
  const newSlidesPerView = Math.floor(slidesPerView);
  const maxIndex = childrenAmount - 1;
  const newIndex = activeSlide + newSlidesPerView;
  return newIndex > maxIndex ? 0 : newIndex;
};
const getPreviousIndex = (activeSlide, slidesPerView, childrenAmount, infinite) => {
  const newSlidesPerView = Math.floor(slidesPerView);
  let newIndex = activeSlide - newSlidesPerView;
  if (newIndex < 0) {
    newIndex = childrenAmount - lastPageSlidesAmount(childrenAmount, newSlidesPerView);
  }
  const lastPageIndex = getPagesNumber(childrenAmount, newSlidesPerView) - 1;
  if (getCurrentPage(activeSlide, newSlidesPerView, childrenAmount) === lastPageIndex) {
    const lastPageAmountDiff = !infinite ? newSlidesPerView - lastPageSlidesAmount(childrenAmount, slidesPerView) : 0;
    newIndex = activeSlide - newSlidesPerView + lastPageAmountDiff;
  }
  return newIndex;
};
const getNewIndex = (controlType, childrenAmount, slidesPerView, activeSlide, infinite) => controlType === 'next' ? getNextIndex(activeSlide, slidesPerView, childrenAmount) : getPreviousIndex(activeSlide, slidesPerView, childrenAmount, infinite);
const getInitialSlide = (initialSlide, childrenAmount, slidesPerView) => {
  const newSlidesPerView = Math.floor(slidesPerView);
  const maxIndex = childrenAmount - 1;
  if (newSlidesPerView === 1) return initialSlide;
  if (initialSlide < 0) return 0;
  if (initialSlide > maxIndex) return maxIndex - maxIndex % newSlidesPerView;
  return initialSlide - initialSlide % newSlidesPerView;
};
const isNextControlDisabled = (slidesPerView, activeSlide, childrenAmount) => {
  const newSlidesPerView = Math.floor(slidesPerView);
  if (newSlidesPerView === 1) {
    return activeSlide === childrenAmount - 1;
  }
  const currentPage = getCurrentPage(activeSlide, newSlidesPerView, childrenAmount);
  const lastPageIndex = getPagesNumber(childrenAmount, newSlidesPerView) - 1;
  return currentPage === lastPageIndex;
};
const isPreviousControlDisabled = (slidesPerView, activeSlide, childrenAmount) => {
  const newSlidesPerView = Math.floor(slidesPerView);
  return newSlidesPerView === 1 ? activeSlide === 0 : getCurrentPage(activeSlide, newSlidesPerView, childrenAmount) === 0;
};
const isControlDisabled = (controlType, infinite, slidesPerView, childrenAmount, activeSlide) => {
  const newSlidesPerView = Math.floor(slidesPerView);
  if (infinite) return false;
  return controlType === 'next' ? isNextControlDisabled(newSlidesPerView, activeSlide, childrenAmount) : isPreviousControlDisabled(newSlidesPerView, activeSlide, childrenAmount);
};
const isSlideInLastPage = (slideIndex, activeSlide, slidesPerView, childrenAmount) => childrenAmount - slideIndex <= slidesPerView && activeSlide >= childrenAmount - slidesPerView;
const isSlideActive = (slideIndex, activeSlide, slidesPerView, childrenAmount) => {
  const newSlidesPerView = Math.floor(slidesPerView);
  if (newSlidesPerView === 1) {
    return slideIndex === activeSlide;
  }
  if (isSlideInLastPage(slideIndex, activeSlide, slidesPerView, childrenAmount)) {
    return true;
  }
  const currentPage = getCurrentPage(activeSlide, newSlidesPerView, childrenAmount);
  const currentPageMinIndex = currentPage * newSlidesPerView;
  const currentPageMaxIndex = currentPageMinIndex + newSlidesPerView - 1;
  return slideIndex >= currentPageMinIndex && slideIndex <= currentPageMaxIndex;
};
const ARROWS_SIZE_LARGE = 'large';
const ARROWS_VISIBILITY_ALWAYS = 'always';
const ARROWS_VISIBILITY_HOVER = 'hover';
const getVisibility = visibility => {
  if (typeof visibility === 'boolean') {
    return visibility ? ARROWS_VISIBILITY_ALWAYS : ARROWS_VISIBILITY_HOVER;
  }
  return ARROWS_VISIBILITY_ALWAYS;
};
const computeArrowsProps = _ref => {
  let {
    arrows: arrowsProp,
    arrowsSize: arrowsSizeProp,
    arrowsVisible: arrowsVisibleProp
  } = _ref;
  const arrowsConfig = {};
  if (!arrowsProp) return undefined;
  if (typeof arrowsProp === 'boolean') {
    return {
      size: arrowsSizeProp || ARROWS_SIZE_LARGE,
      visibility: getVisibility(arrowsVisibleProp)
    };
  }
  const {
    size: sizeConfig,
    visibility: visibilityConfig
  } = arrowsProp;
  arrowsConfig.size = sizeConfig || arrowsSizeProp || ARROWS_SIZE_LARGE;
  if (visibilityConfig) {
    arrowsConfig.visibility = visibilityConfig;
  } else {
    arrowsConfig.visibility = getVisibility(arrowsVisibleProp);
  }
  return arrowsConfig;
};
var computeArrowsProps$1 = computeArrowsProps;
const PAGINATION_MODE_DARK = 'dark';
const PAGINATION_POSITION_BOTTOM = 'bottom';
const computePaginationProps = _ref => {
  let {
    pagination: paginationProp,
    paginationMode: paginationModeProp,
    paginationPosition: paginationPositionProp
  } = _ref;
  const paginationConfig = {};
  if (!paginationProp) return undefined;
  if (typeof paginationProp === 'boolean') {
    return {
      mode: paginationModeProp || PAGINATION_MODE_DARK,
      position: paginationPositionProp || PAGINATION_POSITION_BOTTOM
    };
  }
  const {
    mode: modeConfig,
    position: positionConfig
  } = paginationProp;
  paginationConfig.mode = modeConfig || paginationModeProp || PAGINATION_MODE_DARK;
  paginationConfig.position = positionConfig || paginationPositionProp || PAGINATION_POSITION_BOTTOM;
  return paginationConfig;
};
var computePaginationProps$1 = computePaginationProps;
const AUTOPLAY_DEFAULT_SPEED = 3000;
const computeAutoplayProps = _ref => {
  let {
    autoplay: autoplayProp,
    autoplaySpeed: autoplaySpeedProp
  } = _ref;
  const autoplayConfig = {};
  if (!autoplayProp) return undefined;
  if (typeof autoplayProp === 'boolean') {
    return {
      speed: autoplaySpeedProp || AUTOPLAY_DEFAULT_SPEED
    };
  }
  const {
    speed: speedConfig
  } = autoplayProp;
  autoplayConfig.speed = speedConfig || autoplaySpeedProp || AUTOPLAY_DEFAULT_SPEED;
  return autoplayConfig;
};
var computeAutoplayProps$1 = computeAutoplayProps;
const hasObjectChanged = (prevObject, newObject) => {
  const keys1 = Object.keys(prevObject);
  const keys2 = Object.keys(newObject);
  if (keys1.length !== keys2.length) return true;
  for (let i = 0; i < keys1.length; i += 1) {
    if (prevObject[keys1[i]] !== newObject[keys1[i]]) return true;
  }
  return false;
};
var hasObjectChanged$1 = hasObjectChanged;
class CarouselSnapped extends React__default["default"].Component {
  constructor(props) {
    super(props);
    this.state = {
      activeSlide: this.computedInitialSlide,
      isHovered: false,
      mainContainerState: undefined
    };
    this.swiper = undefined;
    this.mainContainer = undefined;
    this.wrapper = undefined;
    this.autoplayInterval = undefined;
    this.setMainContainerRef = this.setMainContainerRef.bind(this);
    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.swiperConfigurationHasChangedAfterUpdate = this.swiperConfigurationHasChangedAfterUpdate.bind(this);
    this.createNewSwiperInstance = this.createNewSwiperInstance.bind(this);
    this.destroyCurrentSwiperInstance = this.destroyCurrentSwiperInstance.bind(this);
    this.handleBeforeSlide = this.handleBeforeSlide.bind(this);
    this.handleAfterSlide = this.handleAfterSlide.bind(this);
    this.addEventListeners = this.addEventListeners.bind(this);
    this.removeEventListeners = this.removeEventListeners.bind(this);
    this.swiperInstanceSetup = this.swiperInstanceSetup.bind(this);
    this.getEnhancedChildren = this.getEnhancedChildren.bind(this);
    this.getControl = this.getControl.bind(this);
    this.computeArrowsPosition = this.computeArrowsPosition.bind(this);
    this.getControlProps = this.getControlProps.bind(this);
    this.handleWindowResize = this.handleWindowResize.bind(this);
    this.handleFocusOut = this.handleFocusOut.bind(this);
    this.handleOnMouseEnter = this.handleOnMouseEnter.bind(this);
    this.handleOnMouseLeave = this.handleOnMouseLeave.bind(this);
    this.handleControlClick = this.handleControlClick.bind(this);
    this.handlePageClick = this.handlePageClick.bind(this);
    this.hideAuxiliarSlides = this.hideAuxiliarSlides.bind(this);
    this.play = this.play.bind(this);
    this.stop = this.stop.bind(this);
  }
  componentDidMount() {
    this.createNewSwiperInstance();
  }
  componentDidUpdate(prevProps) {
    if (this.swiperConfigurationHasChangedAfterUpdate(prevProps)) {
      this.destroyCurrentSwiperInstance();
      this.createNewSwiperInstance();
    }
  }
  componentWillUnmount() {
    this.destroyCurrentSwiperInstance();
  }
  setMainContainerRef(ref) {
    const {
      innerRef
    } = this.props;
    this.mainContainer = ref;
    this.setState({
      mainContainerState: ref
    });
    if (innerRef) {
      if (typeof innerRef === 'function') {
        innerRef(ref);
      } else {
        innerRef.current = ref;
      }
    }
  }
  setWrapperRef(ref) {
    this.wrapper = ref;
  }
  swiperConfigurationHasChangedAfterUpdate(prevProps) {
    const {
      infinite = false,
      lazyload = true,
      slidesPerView = 1,
      spacing = 12,
      speed = 350,
      type = 'content',
      thresholdSlide = 0
    } = this.props;
    const {
      infinite: prevInfinite = false,
      lazyload: prevLazyload = true,
      slidesPerView: prevSlidesPerView = 1,
      spacing: prevSpacing = 12,
      speed: prevSpeed = 350,
      type: prevType = 'content',
      thresholdSlide: prevThreshold = 0,
      initialSlide: prevInitialSlide = 0
    } = prevProps;
    const previousArrowsConfig = computeArrowsProps$1({
      arrows: prevProps.arrows,
      arrowsSize: prevProps.arrowsSize,
      arrowsVisible: prevProps.arrowsVisible
    });
    const previousComputedInitialSlide = getInitialSlide(prevInitialSlide, React.Children.count(prevProps.children), prevSlidesPerView);
    return prevLazyload !== lazyload || prevType !== type || prevSpacing !== spacing || prevInfinite !== infinite || prevSlidesPerView !== slidesPerView || prevThreshold !== thresholdSlide || prevSpeed !== speed || previousComputedInitialSlide !== this.computedInitialSlide || previousArrowsConfig && this.arrowsConfig && hasObjectChanged$1(previousArrowsConfig, this.arrowsConfig);
  }
  createNewSwiperInstance() {
    const {
      id,
      infinite = false,
      lazyload = true,
      spacing = 12,
      speed = 350,
      type = 'content'
    } = this.props;
    const plugins = [this.swiperInstanceSetup];
    if (lazyload) {
      plugins.push(lazyLoad);
    }
    const swiperOptions = {
      wrapperClass: wrapperNamespace,
      slideClass: slideNamespace,
      slidePrevClass: previousSlideNamespace,
      slideActiveClass: activeSlideNamespace,
      slideNextClass: nextSlideNamespace,
      resistanceRatio: 0.95,
      longSwipesRatio: 0.25,
      spaceBetween: type === 'full' ? 0 : spacing,
      loop: infinite,
      slidesPerView: this.slidesPerView,
      initialSlide: this.computedInitialSlide,
      speed,
      plugins,
      touchMoveStopPropagation: true,
      navigation: {}
    };
    if (this.slidesPerView === 1 && this.arrowsConfig) {
      swiperOptions.plugins.push(SwiperPluginNavigation$1);
      swiperOptions.navigation = {
        prevEl: '[data-andes-carousel-snapped-control=\'previous\']',
        nextEl: '[data-andes-carousel-snapped-control=\'next\']'
      };
    }
    this.swiper = new Swiper$1(this.mainContainer || (id ? "#".concat(id) : '[data-andes-carousel-snapped-main]'), swiperOptions, id);
    this.swiper.on('before-slide', this.handleBeforeSlide);
    this.swiper.on('after-slide', this.handleAfterSlide);
    this.addEventListeners();
  }
  destroyCurrentSwiperInstance() {
    this.swiper.destroy();
    clearInterval(this.autoplayInterval);
    this.removeEventListeners();
  }
  handleBeforeSlide(currentIndex, _state, newIndex) {
    const {
      beforeChange
    } = this.props;
    this.setState({
      activeSlide: newIndex
    });
    if (typeof beforeChange === 'function') beforeChange(currentIndex, newIndex);
  }
  handleAfterSlide(newIndex) {
    const {
      afterChange
    } = this.props;
    if (typeof afterChange === 'function') afterChange(newIndex);
  }
  addEventListeners() {
    if (typeof window !== 'undefined') window.addEventListener('resize', this.handleWindowResize);
    if (this.mainContainer) {
      this.mainContainer.addEventListener('focusin', this.stop);
      this.mainContainer.addEventListener('focusout', this.handleFocusOut);
      this.mainContainer.addEventListener('touchstart', this.stop);
      this.mainContainer.addEventListener('touchend', this.play);
    }
  }
  removeEventListeners() {
    if (typeof window !== 'undefined') window.removeEventListener('resize', this.handleWindowResize);
    if (this.mainContainer) {
      this.mainContainer.removeEventListener('focusin', this.stop);
      this.mainContainer.removeEventListener('focusout', this.handleFocusOut);
      this.mainContainer.removeEventListener('touchstart', this.stop);
      this.mainContainer.removeEventListener('touchend', this.play);
    }
  }
  swiperInstanceSetup(instance) {
    const {
      infinite = false
    } = this.props;
    instance.on('after-init', () => {
      if (infinite) this.hideAuxiliarSlides();
    });
    instance.env.touchable = true;
    if (this.autoplayConfig) setTimeout(this.play, 100);
  }
  get childrenAmount() {
    const {
      children
    } = this.props;
    return React.Children.count(children);
  }
  get computedInitialSlide() {
    const {
      initialSlide = 0
    } = this.props;
    return getInitialSlide(initialSlide, this.childrenAmount, this.slidesPerView);
  }
  get autoplayConfig() {
    const {
      autoplay = false,
      autoplaySpeed
    } = this.props;
    return computeAutoplayProps$1({
      autoplay,
      autoplaySpeed
    });
  }
  get arrowsConfig() {
    const {
      arrows = true,
      arrowsSize,
      arrowsVisible
    } = this.props;
    return computeArrowsProps$1({
      arrows,
      arrowsSize,
      arrowsVisible
    });
  }
  get paginationConfig() {
    const {
      pagination = true,
      paginationMode,
      paginationPosition
    } = this.props;
    return computePaginationProps$1({
      pagination,
      paginationMode,
      paginationPosition
    });
  }
  get pagesAmount() {
    return getPagesNumber(this.childrenAmount, this.slidesPerView);
  }
  get currentPage() {
    const {
      activeSlide
    } = this.state;
    return getCurrentPage(activeSlide, this.slidesPerView, this.childrenAmount);
  }
  get slidesPerView() {
    const {
      slidesPerView = 1,
      thresholdSlide = 0
    } = this.props;
    let newSlidesPerView;
    if (thresholdSlide >= 100) {
      newSlidesPerView = parseInt(String(slidesPerView), 10) + 1;
    } else {
      const thresholdSlideDecimal = typeof thresholdSlide === 'number' ? Math.abs(thresholdSlide) / 100 : 0;
      newSlidesPerView = parseInt(String(slidesPerView), 10) + thresholdSlideDecimal;
    }
    return newSlidesPerView;
  }
  getEnhancedChildren(i18n) {
    const {
      children,
      spacing = 12,
      type = 'content'
    } = this.props;
    const {
      activeSlide
    } = this.state;
    return React.Children.map(children, (child, index) => /*#__PURE__*/React.cloneElement(child, {
      slideIndex: index + 1,
      slidesAmount: this.childrenAmount,
      isActive: isSlideActive(index, activeSlide, this.slidesPerView, this.childrenAmount),
      spacing: type === 'full' ? 0 : spacing,
      slidesPerView: this.slidesPerView,
      i18n
    }));
  }
  getControl(controlType) {
    const {
      arrows = true,
      extend
    } = this.props;
    if (extend && typeof arrows === 'object') {
      const arrowConfig = arrows[controlType];
      if (arrowConfig && arrowConfig !== null && arrowConfig !== void 0 && arrowConfig.component) return arrowConfig.component(this.getControlProps(controlType));
    }
    return this.arrowsConfig && /*#__PURE__*/_jsx__default["default"](CarouselSnappedControl$1, {
      type: controlType
    });
  }
  computeArrowsPosition(controlType) {
    var _arrows$controlType;
    const {
      arrows = true
    } = this.props;
    const position = typeof arrows === 'object' && ((_arrows$controlType = arrows[controlType]) === null || _arrows$controlType === void 0 ? void 0 : _arrows$controlType.position);
    if (!position) return controlType === 'previous' ? 'left' : 'right';
    return position;
  }
  getControlProps(controlType) {
    var _arrows$controlType2, _arrows$controlType3, _this$arrowsConfig, _this$arrowsConfig2;
    const {
      arrows = true,
      extend,
      i18n,
      infinite = false
    } = this.props;
    const {
      activeSlide
    } = this.state;
    const controlProps = {
      disabled: isControlDisabled(controlType, infinite, this.slidesPerView, this.childrenAmount, activeSlide),
      i18n,
      offsetX: extend ? (_arrows$controlType2 = arrows[controlType]) === null || _arrows$controlType2 === void 0 ? void 0 : _arrows$controlType2.offsetX : undefined,
      offsetY: extend ? (_arrows$controlType3 = arrows[controlType]) === null || _arrows$controlType3 === void 0 ? void 0 : _arrows$controlType3.offsetY : undefined,
      position: extend ? this.computeArrowsPosition(controlType) : undefined,
      size: (_this$arrowsConfig = this.arrowsConfig) === null || _this$arrowsConfig === void 0 ? void 0 : _this$arrowsConfig.size,
      visibility: ((_this$arrowsConfig2 = this.arrowsConfig) === null || _this$arrowsConfig2 === void 0 ? void 0 : _this$arrowsConfig2.visibility) === ARROWS_VISIBILITY_ALWAYS,
      type: controlType
    };
    return controlProps;
  }
  hideAuxiliarSlides() {
    const removeElementFocus = element => {
      if (element && element.nodeType === 1) {
        var _element$childNodes;
        element.tabIndex = -1;
        if ((_element$childNodes = element.childNodes) !== null && _element$childNodes !== void 0 && _element$childNodes.length) {
          Array.prototype.slice.call(element.childNodes).forEach(child => removeElementFocus(child));
        }
      }
    };
    if (this.wrapper) {
      const slidesList = Array.prototype.slice.call(this.wrapper.querySelectorAll(".".concat(slideNamespace)));
      const auxSlidesPreviousGroup = slidesList.slice(0, this.slidesPerView);
      const auxSlidesFinalGroup = slidesList.slice(-this.slidesPerView);
      [...auxSlidesPreviousGroup, ...auxSlidesFinalGroup].forEach(slide => {
        slide.setAttribute('aria-hidden', true);
        removeElementFocus(slide);
      });
    }
  }
  handleWindowResize() {
    if (this.swiper) this.swiper.updateSize();
  }
  handleFocusOut() {
    const {
      isHovered
    } = this.state;
    const {
      autoplay
    } = this.props;
    if (!isHovered && autoplay) this.play();
  }
  handleOnMouseEnter() {
    const {
      autoplay
    } = this.props;
    if (!autoplay) return;
    this.setState({
      isHovered: true
    });
    this.stop();
  }
  handleOnMouseLeave() {
    const {
      autoplay
    } = this.props;
    if (!autoplay) return;
    this.setState({
      isHovered: false
    });
    this.play();
  }
  handleControlClick(controlType) {
    const {
      infinite = false
    } = this.props;
    const {
      activeSlide
    } = this.state;
    if (this.swiper) {
      const newIndex = getNewIndex(controlType, this.childrenAmount, this.slidesPerView, activeSlide, infinite);
      this.swiper.slideTo(newIndex);
    }
  }
  handlePageClick(page) {
    if (this.swiper) {
      const newPage = this.slidesPerView > 1 ? this.slidesPerView * page : page;
      this.swiper.slideTo(newPage);
    }
  }
  play() {
    let prefersReducedMotion;
    if (typeof window !== 'undefined') {
      prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }
    if (!prefersReducedMotion && this.swiper && this.autoplayConfig) {
      const {
        env,
        state
      } = this.swiper;
      clearInterval(this.autoplayInterval);
      this.autoplayInterval = setInterval(() => {
        if (this.slidesPerView > 1) {
          const newIndex = getNextIndex(state.index, this.slidesPerView, this.childrenAmount);
          this.swiper.slideTo(newIndex);
        } else {
          const newIndex = state.index + 1;
          this.swiper.slideTo(newIndex > env.limitation.maxIndex ? env.limitation.minIndex : newIndex);
        }
      }, this.autoplayConfig.speed);
    }
  }
  stop() {
    if (this.autoplayConfig) {
      clearInterval(this.autoplayInterval);
      this.autoplayInterval = undefined;
    }
  }
  render() {
    var _this$paginationConfi, _this$paginationConfi2, _this$arrowsConfig3, _this$paginationConfi3, _this$paginationConfi4, _this$paginationConfi5, _this$paginationConfi6, _this$paginationConfi7, _this$paginationConfi8;
    const {
      'aria-label': ariaLabel,
      className,
      extend,
      i18n,
      id,
      onClick,
      pagination = true,
      scroll = 'hidden',
      srLabel,
      strictBoundaries = true,
      title,
      type = 'content'
    } = this.props;
    const {
      mainContainerState
    } = this.state;
    const isBottomPagination = this.paginationConfig && (((_this$paginationConfi = this.paginationConfig) === null || _this$paginationConfi === void 0 ? void 0 : _this$paginationConfi.position) === 'bottom' || type === 'full');
    const isTopPagination = this.paginationConfig && !extend && ((_this$paginationConfi2 = this.paginationConfig) === null || _this$paginationConfi2 === void 0 ? void 0 : _this$paginationConfi2.position) === 'top' && type !== 'full';
    const containerClassNames = classNames__default["default"]("".concat(namespace, "__container"), {
      ["".concat(namespace, "__container--").concat(type)]: type,
      ["".concat(namespace, "__container--with-controls")]: this.arrowsConfig,
      ["".concat(namespace, "__container--strict-boundaries")]: strictBoundaries,
      ["".concat(namespace, "__container--arrows-visible")]: ((_this$arrowsConfig3 = this.arrowsConfig) === null || _this$arrowsConfig3 === void 0 ? void 0 : _this$arrowsConfig3.visibility) === ARROWS_VISIBILITY_ALWAYS,
      ["".concat(namespace, "__container--pagination-position-top")]: ((_this$paginationConfi3 = this.paginationConfig) === null || _this$paginationConfi3 === void 0 ? void 0 : _this$paginationConfi3.position) === 'top' && type !== 'full'
    });
    const carouselClassNames = classNames__default["default"](namespace, className, {
      ["".concat(namespace, "--scroll-").concat(scroll)]: scroll
    });
    const mainContainerProps = {
      'aria-label': srLabel || ariaLabel,
      'aria-labelledby': title ? "".concat(id, "-title") : undefined,
      'aria-roledescription': i18n.pgettext(namespace, 'Carrusel'),
      className: containerClassNames,
      id,
      onClick,
      onMouseEnter: this.handleOnMouseEnter,
      onMouseLeave: this.handleOnMouseLeave,
      ref: this.setMainContainerRef
    };
    const paginationCommonProps = {
      pagesAmount: this.pagesAmount,
      currentPage: this.currentPage,
      mode: (_this$paginationConfi4 = this.paginationConfig) === null || _this$paginationConfi4 === void 0 ? void 0 : _this$paginationConfi4.mode,
      i18n,
      onClick: this.handlePageClick
    };
    const paginationCustomProps = extend && typeof pagination === 'object' && 'custom' in pagination && (pagination === null || pagination === void 0 ? void 0 : pagination.custom);
    return /*#__PURE__*/_jsx__default["default"](carouselSnapped.CarouselSnappedContext.Provider, {
      value: {
        pagination: {
          pagesAmount: this.pagesAmount,
          currentPage: this.currentPage,
          position: extend ? (paginationCustomProps === null || paginationCustomProps === void 0 ? void 0 : paginationCustomProps.position) || 'bottom' : undefined,
          offsetX: extend ? paginationCustomProps === null || paginationCustomProps === void 0 ? void 0 : paginationCustomProps.offsetX : undefined,
          offsetY: extend ? paginationCustomProps === null || paginationCustomProps === void 0 ? void 0 : paginationCustomProps.offsetY : undefined
        },
        carouselType: type,
        container: mainContainerState,
        controls: {
          next: _objectSpread__default["default"](_objectSpread__default["default"]({}, this.getControlProps('next')), {}, {
            onClick: this.slidesPerView > 1 ? () => this.handleControlClick('next') : undefined
          }),
          previous: _objectSpread__default["default"](_objectSpread__default["default"]({}, this.getControlProps('previous')), {}, {
            onClick: this.slidesPerView > 1 ? () => this.handleControlClick('previous') : undefined
          })
        }
      }
    }, void 0, /*#__PURE__*/React__default["default"].createElement("section", _extends__default["default"]({}, mainContainerProps, {
      "data-andes-carousel-snapped-main": true
    }), /*#__PURE__*/_jsx__default["default"]("div", {
      className: "".concat(namespace, "__header")
    }, void 0, title && /*#__PURE__*/_jsx__default["default"]("span", {
      className: "".concat(namespace, "__title"),
      id: "".concat(id, "-title")
    }, void 0, title), isTopPagination && /*#__PURE__*/_jsx__default["default"](CarouselSnappedPagination$1, {
      position: (_this$paginationConfi5 = this.paginationConfig) === null || _this$paginationConfi5 === void 0 ? void 0 : _this$paginationConfi5.position,
      mode: (_this$paginationConfi6 = this.paginationConfig) === null || _this$paginationConfi6 === void 0 ? void 0 : _this$paginationConfi6.mode
    })), /*#__PURE__*/_jsx__default["default"]("div", {
      className: "".concat(namespace, "__controls-wrapper")
    }, void 0, this.getControl('previous'), /*#__PURE__*/_jsx__default["default"]("div", {
      className: carouselClassNames
    }, void 0, /*#__PURE__*/React__default["default"].createElement("div", {
      className: "".concat(namespace, "__wrapper"),
      ref: this.setWrapperRef
    }, this.getEnhancedChildren(i18n))), this.getControl('next')), paginationCustomProps && paginationCustomProps !== null && paginationCustomProps !== void 0 && paginationCustomProps.component ? paginationCustomProps.component(paginationCommonProps) : isBottomPagination && /*#__PURE__*/_jsx__default["default"](CarouselSnappedPagination$1, {
      mode: (_this$paginationConfi7 = this.paginationConfig) === null || _this$paginationConfi7 === void 0 ? void 0 : _this$paginationConfi7.mode,
      position: type === 'full' ? 'inner' : (_this$paginationConfi8 = this.paginationConfig) === null || _this$paginationConfi8 === void 0 ? void 0 : _this$paginationConfi8.position
    })));
  }
}
CarouselSnapped.displayName = 'CarouselSnapped';
var CarouselSnapped$1 = CarouselSnapped;
var module$3 = "@andes/carousel-snapped";
var locale$2 = "en-US";
var translations$2 = {
  "andes-carousel-snapped\u0004Carrusel": [null, "Carousel"],
  "andes-carousel-snapped\u0004{0} de {1}": [null, "{0} of {1}"],
  "andes-carousel-snapped\u0004Anterior": [null, "Previous"],
  "andes-carousel-snapped\u0004Siguiente": [null, "Next"],
  "andes-carousel-snapped\u0004Página {0}": [null, "Page {0}"]
};
var enTranslations = {
  module: module$3,
  locale: locale$2,
  translations: translations$2
};
var module$2 = "@andes/carousel-snapped";
var locale$1 = "es-AR";
var translations$1 = {
  "andes-carousel-snapped\u0004Carrusel": [null, "Carrusel"],
  "andes-carousel-snapped\u0004{0} de {1}": [null, "{0} de {1}"],
  "andes-carousel-snapped\u0004Anterior": [null, "Anterior"],
  "andes-carousel-snapped\u0004Siguiente": [null, "Siguiente"],
  "andes-carousel-snapped\u0004Página {0}": [null, "Página {0}"]
};
var esTranslations = {
  module: module$2,
  locale: locale$1,
  translations: translations$1
};
var module$1 = "@andes/carousel-snapped";
var locale = "pt-BR";
var translations = {
  "andes-carousel-snapped\u0004Carrusel": [null, "Carrossel"],
  "andes-carousel-snapped\u0004{0} de {1}": [null, "{0} de {1}"],
  "andes-carousel-snapped\u0004Anterior": [null, "Anterior"],
  "andes-carousel-snapped\u0004Siguiente": [null, "Seguinte"],
  "andes-carousel-snapped\u0004Página {0}": [null, "Página {0}"]
};
var ptTranslations = {
  module: module$1,
  locale: locale,
  translations: translations
};
const CarouselSnappedContainer = /*#__PURE__*/function () {
  const CarouselSnappedContainer = /*#__PURE__*/React.forwardRef((props, ref) => {
    const componentId = context.useId(props.id);
    const i18n = context.getPatchedI18n(context.AndesContext, enTranslations, esTranslations, ptTranslations);
    return /*#__PURE__*/React__default["default"].createElement(CarouselSnapped$1, _extends__default["default"]({
      innerRef: ref
    }, props, {
      i18n: i18n,
      id: componentId
    }));
  });
  CarouselSnappedContainer.displayName = 'CarouselSnappedContainer';
  return CarouselSnappedContainer;
}();
var CarouselSnappedContainer$1 = common.withTracker(CarouselSnappedContainer, {
  name: 'Carousel-Snapped'
});
function useMounted(value) {
  const [mounted, setMounted] = React.useState(value);
  React.useEffect(() => {
    if (!mounted && value) {
      setMounted(true);
    }
  }, [mounted, value]);
  return mounted;
}
const CarouselSnappedSlide = /*#__PURE__*/function () {
  const CarouselSnappedSlide = /*#__PURE__*/React.forwardRef((_ref, ref) => {
    let {
      children,
      slideIndex,
      slidesAmount,
      isActive = false,
      spacing = 0,
      slidesPerView = 1,
      className,
      i18n
    } = _ref;
    const mounted = useMounted(isActive);
    const innerRef = React.useRef();
    const componentRef = ref || innerRef;
    React.useEffect(() => {
      if (componentRef !== null && componentRef !== void 0 && componentRef.current) {
        const anchorElements = componentRef.current.querySelectorAll('a');
        const buttonElements = componentRef.current.querySelectorAll('button');
        const focusabledElements = [...anchorElements, ...buttonElements];
        focusabledElements.forEach(elem => {
          if (isActive || isMobile__default["default"]()) {
            elem.removeAttribute('tabindex');
          } else {
            elem.setAttribute('tabindex', '-1');
          }
        });
      }
    }, [isActive, componentRef]);
    const injectFocusProps = React.useCallback(child => {
      if (! /*#__PURE__*/React.isValidElement(child)) return child;
      let newChildren = React.Children.map(child.props.children, element => injectFocusProps(element));
      if (React.Children.count(newChildren) === 1) [newChildren] = newChildren;
      const newProps = {
        children: newChildren,
        mounted
      };
      return /*#__PURE__*/React.cloneElement(child, newProps);
    }, [mounted]);
    const enhancedChildren = React.useMemo(() => React.Children.map(children, child => injectFocusProps(child)), [children, injectFocusProps]);
    const slideClassNames = classNames__default["default"](slideNamespace, className, {
      ["".concat(slideNamespace, "--spacing-").concat(spacing)]: spacing
    });
    return /*#__PURE__*/React__default["default"].createElement("div", {
      role: "group",
      className: slideClassNames,
      "aria-hidden": isActive || isMobile__default["default"]() ? undefined : true,
      tabIndex: isActive || isMobile__default["default"]() ? undefined : -1,
      "aria-label": i18n && slideIndex !== undefined && slidesAmount !== undefined ? i18n.pgettext(namespace, '{0} de {1}', slideIndex, slidesAmount) : '',
      style: slidesPerView ? {
        width: "calc(".concat(100 / slidesPerView, "% - ").concat(spacing - spacing / slidesPerView, "px)")
      } : {},
      ref: componentRef
    }, enhancedChildren);
  });
  CarouselSnappedSlide.displayName = 'CarouselSnappedSlide';
  return CarouselSnappedSlide;
}();
var CarouselSnappedSlide$1 = /*#__PURE__*/React.memo(CarouselSnappedSlide);
exports.CarouselSnapped = CarouselSnappedContainer$1;
exports.CarouselSnappedSlide = CarouselSnappedSlide$1;
exports["default"] = CarouselSnappedContainer$1;
